import React, { createContext, useContext, useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = anon, obj = signed in
  const [error, setError] = useState("");

  const refresh = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (_e) {
      setUser(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  async function login(email, password) {
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data?.access_token) localStorage.setItem("caa_access_token", data.access_token);
      setUser(data.user);
      return data.user;
    } catch (e) {
      const msg = formatApiErrorDetail(e.response?.data?.detail) || e.message;
      setError(msg);
      throw new Error(msg);
    }
  }

  async function logout() {
    try {
      await api.post("/auth/logout");
    } catch (_) {}
    localStorage.removeItem("caa_access_token");
    setUser(false);
  }

  async function changePassword(current_password, new_password) {
    setError("");
    try {
      await api.post("/auth/change-password", { current_password, new_password });
      await refresh();
    } catch (e) {
      const msg = formatApiErrorDetail(e.response?.data?.detail) || e.message;
      setError(msg);
      throw new Error(msg);
    }
  }

  return (
    <AuthContext.Provider value={{ user, error, login, logout, changePassword, setError, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
